import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";

import MajorTab1 from "./components/majorTab1";
import MajorTab2 from "./components/majorTab3";
import MajorTab3 from "./components/majorTab4";
import MajorTab4 from "./components/majorTab2";
import MajorTab5 from "./components/majorTab5";
import MajorTab6 from "./components/majorTab6";
import MajorTab7 from "./components/majorTab7";
import MajorTab8 from "./components/majorTab8";
import MajorTab9 from "./components/majorTab9";

import ScrollOut from "scroll-out";

const tabs = ["네트워크 유지보수", "5G 특화망", "미래사업", "전기·전원 관리", "분기국사 FM", "기타"];
const Major = () => {
    const [currentTab, setCurrentTab] = useState(1);
    const [currentTabView, setCurrentTabView] = useState(<MajorTab1 />);

    useEffect(() => {
        ScrollOut({
            threshold: 0.3,
            once: true
        });
    }, []);

    useEffect(() => {
        const hoverElem = document.querySelectorAll(".hoverWraps");

        hoverElem.forEach(elem => {
            elem.addEventListener("mouseenter", e => {
                e.currentTarget.childNodes[0].classList.add("on");
            });
            elem.addEventListener("mouseleave", e => {
                e.currentTarget.childNodes[0].classList.remove("on");
            });
        });
    }, [currentTabView]);

    return (
        <>
            <SubHead title="주요사업" eng="MAJOR BUSINESS"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <div className="sub_tab_wrap">
                        <ul className="sub_tab n03">
                            {/* <li>
                                <a href="#tab1">유무선 네트워크 유지보수</a>
                            </li>
                            <li>
                                <a href="#tab2">재난안전통신망</a>
                            </li>
                            <li className="on">
                                <a href="#tab3">기지국/중계기 운용관리</a>
                            </li>
                            <li>
                                <a href="#tab4">네트워크 망 관리</a>
                            </li>
                            <li>
                                <a href="#tab5">부대시설 관리</a>
                            </li>
                            <li>
                                <a href="#tab6">전기/전원관리&분기국사 FM</a>
                            </li>
                            <li>
                                <a href="#tab7">고객관리</a>
                            </li>
                            <li>
                                <a href="#tab8">5G특화망</a>
                            </li>
                            <li>
                                <a href="#tab9">미래사업</a>
                            </li> */}
                            {tabs.map((tab, index) => (
                                <li
                                    className={index + 1 === currentTab ? "on" : ""}
                                    onClick={() => {
                                        setCurrentTab(index + 1);
                                        if (index === 0) setCurrentTabView(<MajorTab1 title={tab} />);
                                        else if (index === 1) setCurrentTabView(<MajorTab2 title={tab} />);
                                        else if (index === 2) setCurrentTabView(<MajorTab3 title={tab} />);
                                        else if (index === 3) setCurrentTabView(<MajorTab4 title={tab} />);
                                        else if (index === 4) setCurrentTabView(<MajorTab5 title={tab} />);
                                        else if (index === 5) setCurrentTabView(<MajorTab6 title={tab} />);
                                        // else if (index === 6) setCurrentTabView(<MajorTab7 title={tab} />);
                                        // else if (index === 7) setCurrentTabView(<MajorTab8 title={tab} />);
                                        // else if (index === 8) setCurrentTabView(<MajorTab9 title={tab} />);
                                    }}
                                >
                                    <a href="javascript:;">{tab}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="major-tab-contents">{currentTabView}</div>
                </div>
            </main>
        </>
    );
};

export default Major;
